'use client';

import {
  GalleryCardComponent as GalleryCard,
  GalleryCardProps,
} from '@vaad1st/component.molecule.gallery-card';
import classNames from 'classnames';
import { checkCardBadge } from 'src/utils';
import { HeadingElementType } from 'src/utils/shared-types';
import styles from './gallery-card.component.module.less';

interface GalleryCardComponentProps extends GalleryCardProps {
  titleElement?: HeadingElementType;
  cardType?: string;
  textIsRich?: boolean;
  halfCardHeight?: boolean;
  'sling:resourceType'?: string;
  'cq:panelTitle'?: string;
}

export default function GalleryCardComponent({
  titleElement = 'h2',
  ...props
}: GalleryCardComponentProps) {
  const cardProps: any = {
    ...props,
    ...(props.badge && { badge: { ...props.badge } }),
    titleElement,
  };

  checkCardBadge(cardProps);
  delete cardProps['cq:panelTitle'];
  delete cardProps['sling:resourceType'];
  delete cardProps.halfCardHeight;
  delete cardProps.cardType;
  delete cardProps.textIsRich;

  return (
    <div
      className={classNames(styles['gallery-card'], {
        [styles['gallery-card__half']]: props.halfCardHeight,
      })}>
      <GalleryCard {...cardProps} />
    </div>
  );
}
